import { PlayerFixturesCard } from './PlayerFixturesCard';
import { buildGameweekWindow } from '@lib/article-blocks/gameweek-window';
import { DEFAULT_FIXTURE_COUNT } from '@lib/article-blocks/registry';
import type {
  ArticleBlockData,
  SanityPlayerFixturesBlock
} from '@lib/article-blocks/types';

type PlayerFixturesBlockProps = {
  value: SanityPlayerFixturesBlock;
  data: ArticleBlockData;
};

/**
 * Renders nothing when the referenced player is unknown (left the league, or
 * hydration failed) so the surrounding article still reads cleanly.
 */
export const PlayerFixturesBlock = ({
  value,
  data
}: PlayerFixturesBlockProps) => {
  const optaUuid = value.player?.optaUuid;
  const player = optaUuid ? data.playersByOptaUuid[optaUuid] : undefined;
  if (!player) return null;

  const fixtures = data.fixturesByTeamShortName[player.team.shortName] ?? [];
  const gameweeks = buildGameweekWindow(
    fixtures,
    data.currentGameweek,
    value.fixtureCount ?? DEFAULT_FIXTURE_COUNT
  );

  return <PlayerFixturesCard player={player} gameweeks={gameweeks} />;
};
